import moment from 'moment';
import { DateRange } from './DatePicker.types';

export const DEFAULT_NUMBER_OF_MONTHS = 6;

export const DEFAULT_SELECTED_RANGE: DateRange = {
  start: moment().startOf('day').toDate(),
  end: moment().add(3, 'weeks').startOf('day').toDate(),
} as const;
